import videojs from "video.js";
// Scroll element add class for animation
let videoPlay = (selector, options = {}) => {
  let els = document.querySelectorAll(selector);
  els = Array.from(els);
  els.forEach((el) => {
    addObserver(el, options);
  });
};

let addObserver = (el, options) => {
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (options.cb) {
          options.cb(el);
        } else {
          entry.target.classList.add("active");
        }
        observer.unobserve(entry.target);
      }
    });
  }, options);
  observer.observe(el);
};

// Video Home
try {
  let homeHeroVideoDesktop = videojs("video-home-hero-desktop", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  let homeHeroVideoMob = videojs("video-home-hero-mob", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  setTimeout(() => {
    // media query event handler
    if (matchMedia) {
      const mq = window.matchMedia("(min-width: 640px)");
      mq.addListener(WidthChange);
      WidthChange(mq);
    }

    // media query change
    function WidthChange(mq) {
      if (mq.matches) {
        homeHeroVideoDesktop.play();
      } else {
        homeHeroVideoMob.play();
      }
    }
  }, 3000);

  let homeVideoBg = videojs("video-bg-home", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  videoPlay("#video-bg-home-section", {
    cb: function (el) {
      homeVideoBg.autoplay(true);
      homeVideoBg.play();
    },
  });
} catch (err) {
  console.log(err);
}

// Video Button Color is
let colorIsVideoButton = document.querySelector(".color-is__hero-button");

// Video Color is
try {
  let colorIsVideo = videojs("video-color-is", {
    controls: true,
    autoplay: false,
    preload: "auto",
    bigPlayButton: false,
  });

  let colorIsVideoBg = videojs("video-bg-color-is", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  videoPlay("#video-bg", {
    cb: function (el) {
      colorIsVideoBg.autoplay(true);
      colorIsVideoBg.play();
    },
  });

  colorIsVideoButton.addEventListener("click", (e) => {
    colorIsVideo.play();
  });

  colorIsVideo.on("play", () => {
    colorIsVideoButton.setAttribute("style", "display: none;");
  });

  colorIsVideo.on("ended", () => {
    colorIsVideo.initChildren();
    colorIsVideoButton.setAttribute("style", "display: block;");
  });

  colorIsVideo.on("pause", () => {
    colorIsVideoButton.setAttribute("style", "display: block;");
  });
} catch (err) {
  console.log(err);
}

// Video Collections
try {
  let dataSourceVideo = document.querySelector("#video-bg-collection").dataset
    .source;

  const mediaQuery = window.matchMedia("(min-width: 768px)");
  let colorIsVideoBg;

  if (mediaQuery.matches) {
    colorIsVideoBg = videojs("video-bg-collection", {
      controls: false,
      autoplay: false,
      muted: true,
      loop: true,
      inactivityTimeout: 0,
      sources: [
        {
          src: dataSourceVideo + ".mp4",
          type: "video/mp4",
        },
        {
          src: dataSourceVideo + ".webm",
          type: "video/webm",
        },
      ],
    });
  } else {
    colorIsVideoBg = videojs("video-bg-collection", {
      controls: false,
      autoplay: false,
      muted: true,
      loop: true,
      inactivityTimeout: 0,
      sources: [
        {
          src: dataSourceVideo + "-mob.mp4",
          type: "video/mp4",
        },
        {
          src: dataSourceVideo + "-mob.webm",
          type: "video/webm",
        },
      ],
    });
  }

  videoPlay("#video-bg", {
    cb: function (el) {
      colorIsVideoBg.autoplay(true);
      colorIsVideoBg.play();
    },
  });
} catch (err) {
  console.log(err);
}

// Video Button Our story
let ourStoryVideoButton = document.querySelector(
  ".our-story__popup-video-button",
);
let videoPopUpClose = document.querySelectorAll(".js-our-story__popup-close");
let menuIcon = document.querySelector(".menu-icon");

// Video our sstory
try {
  let ourStoryVideo;

  ourStoryVideo = videojs("video-our-story", {
    controls: true,
    autoplay: false,
    preload: "auto",
    bigPlayButton: false,
  });

  ourStoryVideoButton.addEventListener("click", (e) => {
    ourStoryVideo.play();
  });

  ourStoryVideo.on("play", () => {
    ourStoryVideoButton.setAttribute("style", "display: none;");
  });

  ourStoryVideo.on("ended", () => {
    ourStoryVideo.initChildren();
    ourStoryVideoButton.setAttribute("style", "display: block;");
  });

  ourStoryVideo.on("pause", () => {
    ourStoryVideoButton.setAttribute("style", "display: block;");
  });

  Array.from(videoPopUpClose).forEach((item) => {
    item.addEventListener("click", () => {
      ourStoryVideo.pause();
    });
  });

  menuIcon.addEventListener("click", () => {
    ourStoryVideo.pause();
  });
} catch (err) {
  console.log(err);
}

// Video GlobalFit
try {
  // Desktop
  let GlobalFitDesktopVideo = videojs("video-global-fit-desktop", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  // Mobile
  let GlobalFitMobileVideo = videojs("video-global-fit-mobile", {
    controls: false,
    autoplay: false,
    muted: true,
    loop: true,
    inactivityTimeout: 0,
  });

  videoPlay("#video-bg-desktop", {
    cb: function (el) {
      GlobalFitDesktopVideo.autoplay(true);
      GlobalFitDesktopVideo.play();
      console.log(GlobalFitDesktopVideo);
    },
  });

  videoPlay("#video-bg-mobile", {
    cb: function (el) {
      GlobalFitMobileVideo.autoplay(true);
      GlobalFitMobileVideo.play();
    },
  });
} catch (err) {
  console.log(err);
}
